import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet } from 'react-native';

interface HeroBottomGradientProps {
  endColor: string;
  height: number;
}

export const HeroBottomGradient = ({ endColor, height }: HeroBottomGradientProps) => (
  <LinearGradient
    pointerEvents="none"
    colors={['transparent', endColor]}
    start={{ x: 0.5, y: 0 }}
    end={{ x: 0.5, y: 1 }}
    style={[heroBottomGradientStyles.fill, { height }]}
  />
);

export const heroBottomGradientStyles = StyleSheet.create({
  fill: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
  },
});
